
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/watches/[...slug]",
      function () {
        return require("private-next-pages/[lang]/watches/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/watches/[...slug]"])
      });
    }
  